import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { MaintenanceErrorPage } from '@r/page/error/maintenance-error-page.tsx';

interface ErrorProps {
  error: Error;
}

/** Composant d'erreur TanStack Router : journalise Sentry puis affiche la maintenance. */
export const InternalServerError = ({ error }: ErrorProps) => {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return <MaintenanceErrorPage />;
};
